var map = {
	"./account-management-authority.png": "613e",
	"./ali.png": "4d0e",
	"./alipay.png": "060a",
	"./application-integration.png": "cfc3",
	"./automatic-translation.png": "0364",
	"./bg/doc.png": "ec7f",
	"./bg/home.png": "426e",
	"./bg/price.png": "8c28",
	"./customer-database.png": "97c9",
	"./customer-service-bg.png": "a37d",
	"./customer-service-icon.png": "0c16",
	"./doc-bg.png": "01e8",
	"./download-btn.png": "a1d1",
	"./error.png": "1fe8",
	"./group-sending-function.png": "2af6",
	"./home-banner.png": "41bc",
	"./home-screenshot1.png": "43e4",
	"./home-screenshot2.png": "8162",
	"./home-screenshot3.png": "d426",
	"./imgs/achievement/fwxy.png": "44de",
	"./imgs/achievement/fyzqd.png": "9a04",
	"./imgs/achievement/hynm.png": "bfe0",
	"./imgs/achievement/hzqy.png": "5fd0",
	"./imgs/achievement/yhsj.png": "ec1f",
	"./imgs/download/defaultBg.png": "4ada",
	"./imgs/download/hoverBg.png": "3e68",
	"./imgs/footer/footerLogo.png": "10ca",
	"./imgs/footer/telegram.png": "788c",
	"./imgs/footer/wechat.png": "3682",
	"./imgs/footer/whatsapp.png": "b375",
	"./imgs/home/bannerBg.png": "efd3",
	"./imgs/home/choose/choose.png": "398f",
	"./imgs/home/choose/choose1.png": "c7e0",
	"./imgs/home/choose/choose2.png": "e6d7",
	"./imgs/home/choose/chooseBg.png": "37777",
	"./imgs/home/demand/bz.png": "feb8",
	"./imgs/home/demand/demandBg.png": "c9dc",
	"./imgs/home/demand/gj.png": "d832",
	"./imgs/home/demand/hh.png": "9f52",
	"./imgs/home/demand/notSupport.png": "40d3",
	"./imgs/home/demand/support.png": "b5b7",
	"./imgs/home/featuresBg.png": "a0bc",
	"./imgs/home/functions/accountAuth.png": "fdab",
	"./imgs/home/functions/fyqd.png": "679b",
	"./imgs/home/functions/gdgn.png": "9f4c",
	"./imgs/home/functions/khzlk.png": "2c59",
	"./imgs/home/functions/qfgn.png": "527f",
	"./imgs/home/functions/yydk.png": "522f",
	"./imgs/home/functions/yyjc.png": "a4f9",
	"./imgs/home/functions/yyjc1.png": "edde",
	"./imgs/home/functions/zdfy.png": "b11b",
	"./imgs/home/leftA.png": "cf7f",
	"./imgs/home/productFea1.png": "3691",
	"./imgs/home/productFea2.png": "e1c0",
	"./imgs/home/productFea3.png": "afdd",
	"./imgs/home/rightA.png": "3393",
	"./imgs/home/speciality.png": "f9aa",
	"./imgs/kefu.png": "e292",
	"./imgs/loginBg.png": "6452",
	"./imgs/mobile/cNav.png": "2b54",
	"./imgs/mobile/nav.png": "f2eb",
	"./imgs/price/priceBg.png": "09f7",
	"./imgs/replay/ic_01.png": "4beb",
	"./imgs/replay/ic_02.png": "3f8f",
	"./imgs/replay/ic_03.png": "c8ef",
	"./imgs/replay/img01.png": "7de5",
	"./imgs/replay/img02.png": "1f76",
	"./imgs/replay/img03.png": "3643",
	"./imgs/replay/img04.png": "f432",
	"./imgs/replay/img05.png": "1267",
	"./imgs/replay/img06.png": "d4d7",
	"./imgs/replay/img07.png": "a250",
	"./imgs/replay/img08.png": "7efe",
	"./imgs/replay/img09.png": "940e",
	"./imgs/replay/img10.png": "24e6",
	"./imgs/replay/img11.png": "caf2",
	"./imgs/replay/img12.png": "b3da",
	"./imgs/replay/main.png": "f95c",
	"./imgs/sidebar/telegram.png": "1aa7",
	"./imgs/sidebar/whatsapp.png": "f21b",
	"./imgs/sidebar/wx.png": "ad35",
	"./imgs/useDoc/01_1.png": "e0db",
	"./imgs/useDoc/01_2.png": "4999",
	"./imgs/useDoc/02_1.png": "19b9",
	"./imgs/useDoc/02_2.png": "29e5",
	"./imgs/useDoc/03_1.png": "9561",
	"./imgs/useDoc/03_2.png": "e031",
	"./lb1.png": "c693",
	"./lb2.png": "8bfd",
	"./lb3.png": "f52a",
	"./logo.png": "cf05",
	"./more-functions.png": "5988",
	"./multiple-translation-channels.png": "e759",
	"./overuse.png": "059a",
	"./pay-success-ali.png": "1bf1",
	"./pay-success-wechat.png": "511d",
	"./pay-success.png": "96d6",
	"./phone-icon-ac.png": "00d0",
	"./phone-icon.png": "5efe",
	"./price-banner-bg.png": "b238",
	"./product-feature-txt-bg1.png": "aa79",
	"./product-feature-txt-bg2.png": "edd0",
	"./product-feature-txt-bg3.png": "09a7",
	"./product-feature.png": "cade",
	"./qrCode.png": "67b2",
	"./registration-certificate.png": "0928",
	"./slogan.png": "69ef",
	"./software-function.png": "4604",
	"./software-recharge.png": "ac33",
	"./success.png": "6582",
	"./telegram-icon-ac.png": "381e",
	"./telegram-icon.png": "497b",
	"./telegram.png": "c2ea",
	"./translation-skills.png": "4bb1",
	"./wc.png": "6ac9",
	"./wechat.png": "ead3",
	"./whatapp.png": "17f4",
	"./why-select-us.png": "6600",
	"./wx-icon-ac.png": "b9fd",
	"./wx-icon.png": "a020"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";